export enum RequestNotificationsTypes {
    CRM = "CRM_REQUEST_NOTIFICATIONS_STATUS",
}
